/// <reference path="./AbstractEntry.class.ts" />

namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{
			export class NullEntry extends AbstractEntry
			{

				public constructor( orga: OrgaTree )
				{
					super( orga );

					this.clearTitle();
				}

			}
		}
	}
}
